// Module
var code = "<div id=\"{{:: vm.mxAtId}}\" class=\"mx-geo-map\"></div>\r\n<div class=\"mx-loading\" ng-show=\"vm.isLoading\"></div>";
// Exports
export default code;